export const AIMO_PARKING_PAGINATION_DEFAULT_SIZE = 25;

export const AIMO_PARKING_PAGINATION_DEFAULT_INDEX = 1;
